import { Navbar } from "../Components/Navbar/Navbar.jsx";
import Drive from "../Components/Drive/Drive.jsx";
import CirclesBanner from "../Components/ThreeCirclesBanner/CirclesBanner.jsx";
import { Footer } from "../Components/Footer/Footer.jsx";
import { Box } from "@material-ui/core";
import style from "./driver.module.css";

const Driver = () => {
  const circlesSettings = {
    view: "driver",
    first: "Flexibilidad de días y horario de trabajo.",
    second: "Viajes seguros y controlados, con mayor seguridad de pago",
    third:
      "Genera ingresos adicionales, con un mayor flujo de pasajeros y comisiones bajas",
  };

  return (
    <div className={style.conteiner}>
      <Navbar />
      <Drive></Drive>
      <CirclesBanner circlesSettings={circlesSettings} />
      <Footer></Footer>
    </div>
  );
};

export default Driver;
/*    */
